/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/button-has-type */
import React from 'react';

export default function PageHeader(props) {
    return (
        <section className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1>{props.text}</h1>
                    </div>
                    {props.children}
                </div>
            </div>
        </section>
    );

}
